export default __webpack_public_path__ + "static/media/image22.bc9aa207.png";